import React from "react";
import { DeleteIcon, EditIcon } from "assests/GmsIcons";
import { CBM, CONDITIONAL } from "../../ISRConstants";

export type propTypeDoc = {
  id?: any;
  ruleName?: string;
  description?: string;
  ruleExp?: string;
  onClickHandler:Function;
  ruleType:string|undefined|null;
};

const RulesCard = (props: React.PropsWithChildren<propTypeDoc>) => {
  return (
    <div className=" tw-bg-gray-100 tw-rounded tw-border tw-border-zinc-200 tw-mt-5 tw-m-1">
      <div className="tw-flex tw-justify-between tw-items-center ">
        <label className="tw-w-[443px] tw-text-slate-900 tw-text-sm  tw-leading-tight tw-ml-3">
          {props.ruleName}
        </label>
        <div className="tw-flex tw-justify-between tw-items-center">
        <button
          className="tw-m-1 tw-rounded tw-bg-shades-of-grey-0 tw-text-primary  tw-flex tw-flex-row tw-items-center tw-justify-center tw-h-7  tw-py-1 tw-px-2.5 tw-gap-[4px] tw-text-sm  tw-border-[1px] tw-border-solid tw-border-primary"
          onClick={(e) => {props.onClickHandler(props.id, "edit", props.ruleType)}}
        >
          <EditIcon />
        </button>
        <button
          className="tw-m-1 tw-rounded tw-bg-shades-of-grey-0 tw-text-primary  tw-flex tw-flex-row tw-items-center tw-justify-center tw-h-7   tw-py-1 tw-px-2.5 tw-gap-[4px] tw-text-sm  tw-border-[1px] tw-border-solid tw-border-primary"
          onClick={(e) => {props.onClickHandler(props.id, "delete")}}
        >
          <DeleteIcon />
        </button>

        </div>
     
      </div>
      <div className="tw-w-[443px] tw-text-slate-500 tw-text-sm font-normal tw-font-['Noto Sans'] tw-leading-tight tw-ml-3 tw-mb-1">
        {props.description}
      </div>
      <label className="tw-w-[443px] tw-text-slate-900 tw-text-sm  tw-leading-tight tw-ml-3">
          Rule Type: {props.ruleType}
        </label>
      {props?.ruleType !== CBM && props?.ruleType !== CONDITIONAL &&<div className=" tw-bg-gray-100 tw-rounded tw-border tw-border-zinc-200 tw-m-3 tw-break-words tw-p-1">
        {props.ruleExp}
      </div>}
    </div>
  );
};

export default RulesCard;
